// src/components/layout/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Heart } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const Footer: React.FC = () => {
  return (
    <footer className="bg-stone-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Column 1: Company Info */}
          <Card className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(255,127,80,0.5)] hover:border-orange-500">
            <CardContent className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-orange-500">Lux Decor By Kamen</h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <MapPin size={20} className="text-orange-500 mt-1" />
                  <div>
                    <p className="font-medium text-orange-400">Proizvodnja:</p>
                    <p className="text-stone-300">Levarska ulica 3</p>
                    <p className="text-stone-300">2314 Zgornja Polskava</p>
                    <p className="text-stone-300">Slovenija</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <MapPin size={20} className="text-orange-500 mt-1" />
                  <div>
                    <p className="font-medium text-orange-400">Showroom:</p>
                    <p className="text-stone-300">Ptujska cesta 110</p>
                    <p className="text-stone-300">2000 Maribor</p>
                    <p className="text-stone-300">Slovenija</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Column 2: Pohištvo */}
          <Card className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(255,127,80,0.5)] hover:border-orange-500">
            <CardContent className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-orange-500">Pohištvo</h3>
              <ul className="space-y-2">
                <li><Link to="/pohistvo/kolekcija-eleganca" className="text-stone-300 hover:text-orange-400 transition-colors">Kolekcija Eleganca</Link></li>
                <li><Link to="/pohistvo/kolekcija-dobro-pocutje" className="text-stone-300 hover:text-orange-400 transition-colors">Kolekcija Dobro počutje</Link></li>
                <li><Link to="/pohistvo/kolekcija-harmonija" className="text-stone-300 hover:text-orange-400 transition-colors">Kolekcija Harmonija</Link></li>
                <li><Link to="/pohistvo/kolekcija-natur" className="text-stone-300 hover:text-orange-400 transition-colors">Kolekcija Natur</Link></li>
              </ul>
            </CardContent>
          </Card>

          {/* Column 3: Umivalniki */}
          <Card className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(255,127,80,0.5)] hover:border-orange-500">
            <CardContent className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-orange-500">Umivalniki</h3>
              <ul className="space-y-2">
                <li><Link to="/umivalniki/stekleni" className="text-stone-300 hover:text-orange-400 transition-colors">Stekleni umivalniki</Link></li>
                <li><Link to="/umivalniki/glineni" className="text-stone-300 hover:text-orange-400 transition-colors">Glineni umivalniki</Link></li>
                <li><Link to="/umivalniki/betonski" className="text-stone-300 hover:text-orange-400 transition-colors">Betonski umivalniki</Link></li>
                <li><Link to="/umivalniki/resina" className="text-stone-300 hover:text-orange-400 transition-colors">Resina umivalniki</Link></li>
                <li><Link to="/umivalniki/leseni" className="text-stone-300 hover:text-orange-400 transition-colors">Leseni umivalniki</Link></li>
                <li><Link to="/umivalniki/metal" className="text-stone-300 hover:text-orange-400 transition-colors">Metal umivalniki</Link></li>
              </ul>
            </CardContent>
          </Card>

          {/* Column 4: Dodatki */}
          <Card className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(255,127,80,0.5)] hover:border-orange-500">
            <CardContent className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-orange-500">Dodatki</h3>
              <ul className="space-y-2">
                <li><Link to="/dodatki/smolnati" className="text-stone-300 hover:text-orange-400 transition-colors">Smolnati dodatki</Link></li>
                <li><Link to="/dodatki/stekleni" className="text-stone-300 hover:text-orange-400 transition-colors">Stekleni dodatki</Link></li>
                <li><Link to="/dodatki/keramicni" className="text-stone-300 hover:text-orange-400 transition-colors">Keramični dodatki</Link></li>
                <li><Link to="/dodatki/kamniti" className="text-stone-300 hover:text-orange-400 transition-colors">Kamniti dodatki</Link></li>
                <li><Link to="/dodatki/leseni" className="text-stone-300 hover:text-orange-400 transition-colors">Leseni dodatki</Link></li>
                <li><Link to="/dodatki/kovinski" className="text-stone-300 hover:text-orange-400 transition-colors">Kovinski dodatki</Link></li>
              </ul>
            </CardContent>
          </Card>

          {/* Column 5: Links & Social */}
          <Card className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(255,127,80,0.5)] hover:border-orange-500">
            <CardContent className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-orange-500">Povezave</h3>
              <ul className="space-y-2 mb-6">
                <li><Link to="/drobno-pohistvo" className="text-stone-300 hover:text-orange-400 transition-colors">Drobno pohištvo</Link></li>
                <li><Link to="/svetila" className="text-stone-300 hover:text-orange-400 transition-colors">Svetila</Link></li>
                <li><Link to="/ogledala" className="text-stone-300 hover:text-orange-400 transition-colors">Ogledala</Link></li>
                <li><Link to="/pogoji-poslovanja" className="text-stone-300 hover:text-orange-400 transition-colors">Pogoji poslovanja</Link></li>
                <li><Link to="/zasebnost" className="text-stone-300 hover:text-orange-400 transition-colors">Politika zasebnosti</Link></li>
                <li><Link to="/piskotki" className="text-stone-300 hover:text-orange-400 transition-colors">Piškotki</Link></li>
                <li><Link to="/gdpr" className="text-stone-300 hover:text-orange-400 transition-colors">GDPR</Link></li>
              </ul>
              
              <h4 className="text-sm font-semibold mb-3 text-orange-400">Sledite nam:</h4>
              <div className="flex space-x-3">
                <a 
                  href="https://www.instagram.com/lux_decor_kamen/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-stone-700 hover:bg-orange-600 rounded-full transition-colors"
                  aria-label="Instagram"
                >
                  <Button 
                    variant="ghost" 
                    size="icon" 
                    className="text-orange-400 hover:text-white h-9 w-9 rounded-full"
                  >
                    <Instagram size={18} />
                  </Button>
                </a>
                <a 
                  href="https://www.facebook.com/profile.php?id=61567721153960" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-stone-700 hover:bg-orange-600 rounded-full transition-colors"
                  aria-label="Facebook"
                >
                  <Button 
                    variant="ghost" 
                    size="icon" 
                    className="text-orange-400 hover:text-white h-9 w-9 rounded-full"
                  >
                    <Facebook size={18} />
                  </Button>
                </a>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="border-t border-stone-700 mt-10 pt-6 text-center text-stone-400 text-xs">
          <p>&copy; {new Date().getFullYear()} Lux Decor by Kamen. Vse pravice pridržane.</p>
          <p className="mt-2">
            <a href="http://www.kamen.si" target="_blank" rel="noopener noreferrer" className="text-orange-400 hover:text-white transition-colors">
              Salon keramike in kamna
            </a>
          </p>
          <p className="mt-2 flex items-center justify-center gap-1">
            Made with <Heart size={16} className="text-red-500 animate-pulse" /> by <a href="https://digitalpro.dev/" target="_blank" rel="noopener noreferrer" className="text-orange-400 hover:text-white transition-colors">DigitalPro</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;